import * as React from 'react';

import { BaseComponent } from '../BaseComponent';
import { LayoutType } from '../../constants/LayoutConstants';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { SidebarHeader } from '../SidebarHeader';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { SidebarModule } from '../../constants/Enums';

interface ShareBaseTabProps {
    visible: boolean;
    layoutType: LayoutType;
}

export class ShareBaseTab<T> extends BaseComponent<ShareBaseTabProps, T> {
    protected header = (label: string): JSX.Element => {
        const openedInShareMenu: boolean = (
            AppConfigurationStore.getState().shareTypes.filter((shareOption) => { return shareOption.disabled === false; }).length > 1 &&
            (this.props.layoutType === LayoutType.SMALL || false)
        );
        if (openedInShareMenu) {
            return (
                <SidebarHeader headerCallback={() => {ViewSettingsActions.changeSidebar(SidebarModule.SHARE); }} leftArrow={true} text={label}/>
            );
        }
        return (
            <SidebarHeader text={label}/>
        );
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/ShareBaseTab.tsx